import { queueTrackingEvent } from '@library/tracking-integration'

type ResubscribeCtaTrackingEvent = {
  action: 'resubscribe'
  properties: {
    discount_offered_pct: null
    source: 'inactive_homepage'
    resurrection_resubscription_origin: 'value_prop_card'
  }
}

type OrderOneOffBoxCtaTrackingEvent = {
  action: 'order_one_off_box'
  properties: {
    discount_offered_pct: null
    source: 'inactive_homepage'
    transactional_order_origin: 'value_prop_card'
    button_location: 'value_prop_card'
  }
}

export const trackResubscribeCtaClick = () => {
  queueTrackingEvent<ResubscribeCtaTrackingEvent>({
    action: 'resubscribe',
    properties: {
      discount_offered_pct: null,
      source: 'inactive_homepage',
      resurrection_resubscription_origin: 'value_prop_card',
    },
  })
}

export const trackOrderOneOffBoxCtaClick = () => {
  queueTrackingEvent<OrderOneOffBoxCtaTrackingEvent>({
    action: 'order_one_off_box',
    properties: {
      discount_offered_pct: null,
      source: 'inactive_homepage',
      transactional_order_origin: 'value_prop_card',
      button_location: 'value_prop_card',
    },
  })
}
